// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3KYSZ","rootCenter":"LoadMoreObserver_rootCenter__3vjP0","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__38-ed"};